"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _lodash = require("lodash");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _bowser = _interopRequireDefault(require("bowser"));
var _auth_user_store = _interopRequireDefault(require("./auth_user_store"));
var _class;
var AUDIO_FILES = [{
  name: 'tada',
  path: '/sounds/tada',
  volume: 0.3
}, {
  name: 'correctOpponent',
  path: '/sounds/correct_chime_opponent',
  volume: 0.2
}, {
  name: 'failureOpponent',
  path: '/sounds/failure_opponent',
  volume: 0.2
}, {
  name: 'correctChime',
  path: '/sounds/correct_chime',
  volume: 0.3
}, {
  name: 'correct',
  path: '/sounds/correct',
  volume: 0.2
}, {
  name: 'failure',
  path: '/sounds/failure',
  volume: 0.2
}, {
  name: 'lostGame',
  path: '/sounds/lose_game',
  volume: 0.15
}, {
  name: 'wonGame',
  path: '/sounds/winner',
  volume: 0.3
}, {
  name: 'horn',
  path: '/sounds/celebration',
  volume: 0.5
}, {
  name: 'chime',
  path: '/sounds/collection',
  volume: 0.5
}, {
  name: 'countDown',
  path: '/sounds/countdown_10s',
  volume: 0.1,
  looping: true
}];
var SoundEffectStore = (_class = /*#__PURE__*/function () {
  function SoundEffectStore() {
    (0, _classCallCheck2["default"])(this, SoundEffectStore);
  }
  return (0, _createClass2["default"])(SoundEffectStore, [{
    key: "user",
    get: function get() {
      return _auth_user_store["default"].showData;
    }
  }, {
    key: "loadAudio",
    value: function loadAudio() {
      var _this = this;
      this.soundObjects = {};
      var extension = _bowser["default"].safari ? 'wav' : 'ogg';
      (0, _lodash.each)(AUDIO_FILES, function (params) {
        _this.soundObjects[params.name] = new Audio("".concat(params.path, ".").concat(extension));
        _this.soundObjects[params.name].load();
        _this.soundObjects[params.name].loop = !!params.looping;
      });
    }
  }, {
    key: "setNativeAudioPlayer",
    value: function setNativeAudioPlayer(nativeSoundEffectPlayer) {
      this.nativeSoundEffectPlayer = nativeSoundEffectPlayer;
    }
  }, {
    key: "play",
    value: function play(soundEffect) {
      if (this.user && !this.user.useSoundEffects) {
        return;
      }
      if (this.nativeSoundEffectPlayer) {
        this.nativeSoundEffectPlayer.playAudio(soundEffect);
      } else if (!_bowser["default"].safari) {
        this.playAudio(soundEffect);
      }
    }
  }, {
    key: "pause",
    value: function pause(soundEffect) {
      if (this.nativeSoundEffectPlayer) {
        this.nativeSoundEffectPlayer.pauseAudio(soundEffect);
      } else if (!_bowser["default"].safari) {
        this.pauseAudio(soundEffect);
      }
    }
  }, {
    key: "playAudio",
    value: function () {
      var _playAudio = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(soundEffect) {
        var audioFile;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.soundObjects[soundEffect]) {
                audioFile = AUDIO_FILES.filter(function (item) {
                  return item.name === soundEffect;
                })[0];
                if (audioFile && audioFile.volume) {
                  this.soundObjects[soundEffect].volume = audioFile.volume;
                }
                this.soundObjects[soundEffect].play();
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function playAudio(_x) {
        return _playAudio.apply(this, arguments);
      }
      return playAudio;
    }()
  }, {
    key: "pauseAudio",
    value: function () {
      var _pauseAudio = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(soundEffect) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.soundObjects[soundEffect]) {
                this.soundObjects[soundEffect].pause();
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function pauseAudio(_x2) {
        return _pauseAudio.apply(this, arguments);
      }
      return pauseAudio;
    }()
  }]);
}(), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "loadAudio", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "loadAudio"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setNativeAudioPlayer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setNativeAudioPlayer"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "play", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "play"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pause", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "pause"), _class.prototype), _class);
var _default = exports["default"] = new SoundEffectStore();